(() => {
  const MOBILE_BREAKPOINT = '(max-width: 749px)';
  const HIDDEN_CLASS = 'is-hidden';

  class OwaCartStickyCheckoutController {
    constructor() {
      this.footer = null;
      this.target = null;
      this.sticky = null;

      this.mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
      this.intersectionObserver = null;
      this.mutationObserver = null;

      this.onMediaQueryChange = this.refresh.bind(this);
      this.onFallbackCheck = this.checkFallbackVisibility.bind(this);
      this.onFooterMutation = this.refresh.bind(this);
    }

    init() {
      if (!document.body.classList.contains('template-cart')) return;

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.onMediaQueryChange);
      } else if (this.mediaQuery.addListener) {
        this.mediaQuery.addListener(this.onMediaQueryChange);
      }

      this.ensureFooterObserver();
      this.refresh();
    }

    refresh() {
      this.footer = document.getElementById('main-cart-footer');
      this.target = document.querySelector('[data-owa-checkout-target]');
      this.sticky = document.querySelector('[data-owa-sticky-checkout]');

      this.disconnectVisibilityObservers();

      if (!this.sticky) return;

      if (!this.shouldRun() || !this.target) {
        this.setStickyHidden(true);
        return;
      }

      if ('IntersectionObserver' in window) {
        this.checkFallbackVisibility();
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.setStickyHidden(this.shouldHide(entry.isIntersecting));
            });
          },
          { threshold: 0 }
        );
        this.intersectionObserver.observe(this.target);
        return;
      }

      window.addEventListener('scroll', this.onFallbackCheck, { passive: true });
      window.addEventListener('resize', this.onFallbackCheck);
      this.checkFallbackVisibility();
    }

    shouldRun() {
      return document.body.classList.contains('template-cart') && this.mediaQuery.matches;
    }

    shouldHide(targetVisible) {
      if (!this.target) return true;
      if (this.target.hasAttribute('disabled')) return true;
      if (this.footer && this.footer.classList.contains('is-empty')) return true;
      return targetVisible;
    }

    setStickyHidden(hidden) {
      if (!this.sticky) return;
      this.sticky.classList.toggle(HIDDEN_CLASS, hidden);
    }

    checkFallbackVisibility() {
      if (!this.target) return;

      const rect = this.target.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const isVisible = rect.top < viewportHeight && rect.bottom > 0;

      this.setStickyHidden(this.shouldHide(isVisible));
    }

    disconnectVisibilityObservers() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }

      window.removeEventListener('scroll', this.onFallbackCheck);
      window.removeEventListener('resize', this.onFallbackCheck);
    }

    ensureFooterObserver() {
      this.footer = document.getElementById('main-cart-footer');
      if (!this.footer) return;

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }

      this.mutationObserver = new MutationObserver(this.onFooterMutation);
      this.mutationObserver.observe(this.footer, { childList: true, subtree: true });
    }
  }

  function initOwaCartStickyCheckout() {
    if (!document.body.classList.contains('template-cart')) return;

    if (window.__owaCartStickyCheckoutController) {
      window.__owaCartStickyCheckoutController.refresh();
      return;
    }

    const controller = new OwaCartStickyCheckoutController();
    controller.init();
    window.__owaCartStickyCheckoutController = controller;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOwaCartStickyCheckout);
  } else {
    initOwaCartStickyCheckout();
  }

  window.initOwaCartStickyCheckout = initOwaCartStickyCheckout;
})();
